import axios from 'axios';

// when running local app, add REACT_APP_COUNTRY_CODE in environment variables to make sure sending x-country-code to signature-api to determine its au or nz
if (process.env.REACT_APP_COUNTRY_CODE && /^(au|nz)$/i.test(process.env.REACT_APP_COUNTRY_CODE)) {
    axios.defaults.headers.common['x-country-code'] = process.env.REACT_APP_COUNTRY_CODE;
}

export default axios;